import { useState, useEffect } from "react"
import { FileText, BookOpen, Calendar, ExternalLink } from "lucide-react"
import { Button } from "../../components/ui/button"
import SEO from "../SEO"
 
export default function Publications() {
  const [newsArticles, setNewsArticles] = useState([])
  const [loading, setLoading] = useState(true)
 
  useEffect(() => {
    fetch("/wp-json/custom/v1/in-the-news?page_id=21401")
      .then(res => res.json())
      .then(res => {
        // Display the most recent 6 articles from the news feed
        setNewsArticles(res.items?.slice(0, 6) || [])
        setLoading(false)
      })
      .catch(error => {
        console.error("Error fetching news data:", error)
        setLoading(false)
      })
  }, [])
 
  return (
     <>
    <SEO
      title="Research Publications | Pranaam Hospitals"
      description="Explore research publications, medical journals, clinical findings, and healthcare contributions from Pranaam Hospitals."
      canonical="https://pranaamhospitals.com/research/publications"
    />
    <main className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Research Publications</h1>
          <p className="text-lg md:text-xl text-white/90">Contributing to Medical Knowledge</p>
        </div>
      </div>
 
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <img src="/wp-content/uploads/2026/05/HealthcareSpectrum-1.png" alt="Healthcare" className="w-full h-auto max-h-80 object-contain rounded-lg mb-6" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Our Research Contributions</h2>
          <p className="text-gray-600 mb-6">
            Pranaam Hospitals actively contributes to medical literature through research publications,
            case studies, and clinical findings. Our team of expert doctors and researchers regularly
            publish their work in national and international medical journals.
          </p>
        </div>
 
        <div className="space-y-6">
          {loading ? (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
              <p className="mt-4 text-gray-500">Loading latest updates...</p>
            </div>
          ) : newsArticles.map((article, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-4 md:p-6 hover:shadow-md transition-shadow">
              <div className="flex flex-col sm:flex-row items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <FileText className="w-6 h-6 text-primary" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-2">{article.headline}</h3>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                    <div className="flex items-center gap-1">
                      <BookOpen className="w-4 h-4" />
                      <span>{article.publication}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      <span>{article.date}</span>
                    </div>
                  </div>
                </div>
                <div className="mt-4 sm:mt-0 self-center">
                  <Button
                    asChild
                    variant="outline"
                    size="sm"
                    className="text-primary border-primary hover:bg-primary hover:text-white"
                  >
                    <a href={article.link} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                      Read Article
                      <ExternalLink className="w-4 h-4" />
                    </a>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
    </>
  )
}
 